// import styles from "./assets.module.css";
import styles from "../user/user.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { IoSearch } from "react-icons/io5";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import moment from "moment";
import Loader from "../../components/loader";
import ReactPaginate from "react-paginate";
import "../withdraw/pagination.css"

export default function Subscription() {
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalAmount, setTotalAmount] = useState(null);
  const [parameter, setParameter] = useState({
    fromDate: "",
    toDate: "",
    search: "",
    planName: "ALL",
    purchasedBy: "ALL",
    limit: 20,
  });

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };
  const getSubscriptionList = useCallback(async () => {
    if (!userToken) return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.subscription}?page=${currentPage}&search=${parameter?.search}&fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}&planName=${parameter?.planName}&limit=${parameter.limit}&purchasedBy=${parameter?.purchasedBy}`,
        { headers }
      );
      const resData = res?.data?.result[0].data;
      const totalAmount = res?.data?.result[0]?.totalAmount[0]?.totalAmount;
      setTotalAmount(totalAmount);
      setLoading(false);
      setData(resData);
      setTotalPages(res?.data?.result[0].metadata[0].total_page);
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
    }
  }, [currentPage, parameter, userToken]);
  useEffect(() => {
    getSubscriptionList();
  }, [getSubscriptionList]);

  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Subscription Management</h1>
      <div className={styles?.userTopContainer}>
        <div className={styles?.userTopBoxLeft}>
          <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
            <span>Search</span>
            <div className={styles.inputBoxChild}>
              <input
                type="text"
                placeholder="Search by Username, Fullname"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, search: e.target.value });
                }}
                value={parameter?.search}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    getSubscriptionList();
                  }
                }}
              />
              <IoSearch
                className={styles.inputSearchIcon}
                onClick={getSubscriptionList}
              />
            </div>
          </div>
          {/* <div className={styles.selectBox}>
            <span>Status</span>
            <div className={styles.selectBoxChild}>
              <select
                className={styles.selectMain}
                onChange={(e) => {
                  setParameter({
                    ...parameter,
                    planName: e.target.value,
                  });
                }}
                value={parameter?.planName}
              >
                <option className={styles.optionMain} value={"ALL"}>
                  All
                </option>
                <option className={styles.optionMain} value={"Express Diamond"}>
                  Express Diamond
                </option>
                <option className={styles.optionMain} value={"Express Gold"}>
                  Express Gold
                </option>
                <option className={styles.optionMain} value={"Express Pro"}>
                  Express Pro
                </option>
              </select>
            </div>
          </div> */}
            <div className={styles.selectBox} style={{maxWidth:"254px"}}>
            <span>Purchased</span>
            <div className={styles.selectBoxChild}>
              <select
                className={styles.selectMain}
                onChange={(e) => {
                  setParameter({
                    ...parameter,
                    purchasedBy: e.target.value,
                  });
                }}
                value={parameter?.purchasedBy}
              >
                <option className={styles.optionMain} value={"ALL"}>
                  All
                </option>
                <option className={styles.optionMain} value={"USER"}>
                  User
                </option>
                <option className={styles.optionMain} value={"ADMIN"}>
                  Admin
                </option>
              </select>
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>From</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, fromDate: e.target.value });
                }}
                value={parameter?.fromDate}
              />
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>To</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, toDate: e.target.value });
                }}
                value={parameter?.toDate}
              />
            </div>
          </div>
          <div className={styles.userTopBoxRight}>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                setParameter({
                  page: 1,
                  fromDate: "",
                  toDate: "",
                  search: "",
                  planName: "ALL",
                  purchasedBy: "ALL",
                  limit: 20,
                }); getSubscriptionList()
              }}
            >
              Reset
            </button>
          </div>
        </div>

      </div>
      <div className={`${styles.inputBox} ${styles.searchInputBox}`} style={{marginTop:"1rem"}}>
        <span>Total Amount</span>
        <div>
          <input
            type="text"
            className={styles.inputField}
            value={totalAmount}
          />
        </div>
      </div>
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            placeContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader width={"100px"} height={"100px"} />
        </div>
      ) : (
        <>
          {!data || data.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "bold",
              }}
            >
              No Data Found
            </p>
          ) : (
            <div className={styles.tableWrallerUser}>
              <table>
                <tr>
                  <th>
                    {/* <input type="checkbox" className={styles.checkInputTable} /> */}
                    No.
                  </th>
                  <th>Email</th>
                  <th>Full Name</th>
                  {/* <th>IVT ID</th> */}
                  <th>Plan Name</th>
                  <th>Amount</th>
                  <th>Date</th>
                </tr>
                {data?.map((item, index) => {
                  return (
                    <tr>
                      <td>
                        {/* <input
                        type="checkbox"
                        className={styles?.checkInputTable}
                      /> */}
                        {index + 1 + (currentPage - 1) * parameter?.limit}
                      </td>
                      <td>
                        {item?.email ? item.email : 'NA'}
                      </td>
                       <td>
                        {item?.firstName ? (item.firstName + ' ' + (item.lastName ? item.lastName : 'NA')) : 'NA'}
                      </td>
                      {/* <td>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <span>{item?.IVT} </span>
                          <IoCopyOutline
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              navigator.clipboard.writeText(
                                item?.IVT
                              );
                            }}
                          />
                        </div>
                      </td> */}
                      <td>
                        {item?.planName}
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <span>{item?.planPrice.toFixed(4)} </span>
                        </div>
                      </td>
                      <td>
                        {moment.parseZone(item?.createdAt).format("DD-MM-YY | HH:mm:ss")}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          )}
          {(data || !data.length === 0) && (
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
              breakClassName={"ellipsis"}
              pageClassName={"page-item"}
              previousClassName={"previous"}
              nextClassName={"next"}
              forcePage={currentPage - 1}
            />
          )}
        </>
      )}
    </div>
  );
}
